import { useEffect } from 'react'

import { useNetworkConnection } from 'hooks/listeners'
import { usePendingTransactionsListener } from 'hooks/airdrop'
import { useAirdropTransactions, useSendRefund } from 'hooks/airdrop'

import { useIsAirdropFailed, useIsSelfGenerated } from 'state/airdrop/hooks'

import { Icon, Notification } from 'components/ui'

const Updater = () => {
  usePendingTransactionsListener()

  const isOnline = useNetworkConnection()

  const isSelfGenerated = useIsSelfGenerated()
  const isAirdropFailed = useIsAirdropFailed()
  const airdropTransactions = useAirdropTransactions()

  const sendRefund = useSendRefund()

  useEffect(() => {
    if ((airdropTransactions.isMined || isAirdropFailed) && isSelfGenerated) {
      sendRefund()
    }
  }, [airdropTransactions.isMined, isAirdropFailed, isSelfGenerated])

  return (
    <>
      {!isOnline && (
        <Notification type='error' align='center' round='0'>
          <Icon name='connect' size='mediumPlus' />
          No&nbsp;internet connection! Please check your internet connection.
        </Notification>
      )}
    </>
  )
}

export default Updater
